/* Base class (component) for the main COT components. Any business components needs to extend form this*/

import { OnDestroy } from '@angular/core';
import { Subject } from "rxjs/Subject";
import "rxjs/add/operator/takeUntil";
import { CotErrorStateMatcher } from '../services/cot-error-state-matcher';


export abstract class BaseCotFormComponent implements OnDestroy {
    public static readonly EMAIL_REGEX: RegExp = /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@(([0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3})|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
    public readonly minDob: Date = new Date(1800, 0, 1, 0, 0, 0, 0);
    public readonly maxDob: Date = new Date();
    public readonly dobStartAt: Date = new Date();
    public readonly errorStateMatcher: CotErrorStateMatcher = new CotErrorStateMatcher();

    protected static readonly codeDelimiter = "~";
    protected static readonly pickItemDelimiter = "|"
    protected static readonly carriageReturnDelimiter = "\r\n";
    protected emitUnsubscribe: Subject<void> = new Subject();

    constructor() {
        this.dobStartAt.setFullYear(this.dobStartAt.getFullYear() - 10);
    }

    ngOnDestroy() {
        this.emitUnsubscribe.next();
        this.emitUnsubscribe.complete();
    }
}



// WEBPACK FOOTER //
// ./src/app/components/base-cot-form.component.ts